<template>
  <div class="payment-data">
    <div class="helper toast toast--blue">
      {{ status === 'RENEW_CANCELLED' ? $t('account.payments.dateCancellation') : $t('account.payments.datePayment') }} <b>{{ $d(new Date(expiresAt), 'short') }}</b>
    </div>
    <btn href="https://help.playkids.com/pt-BR/collections/7146572-assinaturas" flat>{{ $t('account.payments.howToChange') }}</btn>

  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'payment-data',
  computed: {
    ...mapState({
      expiresAt: state => state.user.subscription.expires_at,
      status: state => state.user.subscription.status
    }),
    canCancel() {
      if (this.subscriptionStatus === 'RENEW_CANCELLED') {
        return false
      }

      return this.subscriptionPlatform !== 'APP_STORE' && this.subscriptionPlatform !== 'GOOGLE_PLAY'
    }
  }
}
</script>

<style lang="scss">
.payment-data {
  .helper {
    display: inline-block;
    margin: 2rem 0;
  }
  .btn {
    display: table;
  }
}
</style>
